// @flow

import { BaseService } from "./base-service";
import { FetchApi } from "../model/fetch";

type User = {
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    postCode: string,
    isTrade: boolean,
    isOptIn: string,
    accountNumber: ?string,
    state: string,
    suburb: string,
};

export class RegisterService extends BaseService {
    constructor(
        fetchApi: FetchApi,
        options: {
            basepath: string
        }
    ) {
        super(fetchApi, options);
    }

    // returns the cookie with the given name,
    // or "" if not found
    getCookie(name: string) {
        const matches = document.cookie.match(
            new RegExp(
                "(?:^|; )" +
                name.replace(/([.$?*|{}()[\]\\/^])/g, "\\$1") +
                "=([^;]*)"
            )
        );
        return matches ? decodeURIComponent(matches[1]) : "";
    }

    // returns a formatted string from the page URL
    // ie reece.com.au:category:hot-water-systems from
    // https://www.reece.com.au/category/hot-water-systems
    getPage() {
        var string = window.location.host.replace("www.", "");
        var pathArray = window.location.pathname.split("/");
        for (let i in pathArray) {
        if (pathArray[i]) {
            string += ":";
            string += pathArray[i];
        }
        }
        return string.toLowerCase();
    }

    // use the global _satellite function to get amcvid
    // if satellite function doesn't work, the id may be stored in a cookie
    getAmcvId() {
        if (window["_satellite"]) {
            return window["_satellite"]
                .getVisitorId()
                .getMarketingCloudVisitorID();
        }
        return this.getCookie("rceoct_amcv");
    }

    // process the user data
    register = async (user: User): Promise<void> => {

        const finalUser = {
            ...user, 
            trackingAmcvId: this.getAmcvId(),
            trackingChannelIds: this.getCookie('rceoct_ids'),
            trackingChannelLocIds: this.getCookie('rceoct_loc_ids'),
            trackingChannelLocPage: this.getCookie('rceoct_loc_page'),
            trackingPage: this.getPage()
        }
        
        return await this.post("/api/register", null, finalUser);
    };
}
